import {  Component             ,
          inject                } from "@angular/core";
import {  FormControl           ,
          ReactiveFormsModule   } from "@angular/forms";
import {  SidebarModule         } from 'primeng/sidebar';

import {  CcFormGroup           } from "app/@shared/forms/form-group/cc-form-group.extention";
import {  CcBaseSidebar         } from "nv@components/cc-sidebar/cc-sidebar.base";
import {  CcSidebar             } from "nv@components/cc-sidebar/cc-sidebar.component";
import {  TemplateImportExcelReport } from "./@templates/template-import/template-import.component";

@Component({
  selector    : 'sidebar-generate-excel-report',
  templateUrl : './generate-excel-report.component.html',
  imports     : [
    ReactiveFormsModule         ,
    SidebarModule               ,
    CcSidebar                   ,
    TemplateImportExcelReport
  ]
})
export class SidebarGenerateExcelReport extends CcBaseSidebar {

  public sidebarTitle = 'Generate Report from Excel';

  public $form = new CcFormGroup({
    file: new FormControl(null),
  });

  public processFile(event: any) {

    const file: File  = event.files[0];
    const formData    = new FormData();
    formData.append('file', file, file.name);

    this.returnToParent(formData);
  }
}
